import {ApiProperty} from "@nestjs/swagger";
import { MaxLength, Matches, IsOptional} from "class-validator";
import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';

export class VisitorDto {
    
    @ApiProperty()
    id:number;

    @ApiProperty()
    requestId: number;

    @ApiProperty()
    visitorName: any;

    @ApiProperty()
    visitorCard: string;

    @ApiProperty()
    checkIn: Date;

    @ApiProperty()
    checkOut: Date;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}